import React from 'react';
import Loadable from 'react-loadable'

// import ContestPriceBreakup from './views/Contests/ContestPriceBreakup';
import PredictionBreakup from './views/Contests/PredictionBreakup';
import PredictionChildView from './views/Contests/PredictionChildView';
import PredictionPriceBreakup from './views/Contests/PredictionPriceBreakup';
import PredictionTrasactionTable from './views/Contests/PredictionTrasactionTable';
import UserWinning from './views/Contests/users_winning';
import OpinionTrading from './views/OpinionTrading/OpinionTrading';
import OpinionTradingDetails from './views/OpinionTrading/OpinionTradingDetails';
import InPlayPrediction from './views/InPlayPrediction/InPlayPrediction';


function Loading() {
  return ( 
    <div><div className={"text-center"} colSpan="8"><i className="fa fa-refresh fa-spin fa-3x fa-fw"></i>
    <span className="sr-only">Loading...</span></div></div>
  )
};

// Lazy load DefaultLayout to avoid circular dependency
const DefaultLayout = Loadable({
  loader: () => import('./containers/DefaultLayout'),
  loading: Loading,
});

const Breadcrumbs = Loadable({
  loader: () => import('./views/Base/Breadcrumbs'),
  loading: Loading,
});

const Cards = Loadable({
  loader: () => import('./views/Base/Cards'),
  loading: Loading,
});

const Carousels = Loadable({
  loader: () => import('./views/Base/Carousels'),
  loading: Loading,
});

const Collapses = Loadable({
  loader: () => import('./views/Base/Collapses'),
  loading: Loading,
});

const Dropdowns = Loadable({
  loader: () => import('./views/Base/Dropdowns'),
  loading: Loading,
});

const Forms = Loadable({
  loader: () => import('./views/Base/Forms'),
  loading: Loading,
});

const Jumbotrons = Loadable({
  loader: () => import('./views/Base/Jumbotrons'),
  loading: Loading,
});

const ListGroups = Loadable({
  loader: () => import('./views/Base/ListGroups'),
  loading: Loading,
});

const Navbars = Loadable({
  loader: () => import('./views/Base/Navbars'),
  loading: Loading,
});

const Navs = Loadable({
  loader: () => import('./views/Base/Navs'),
  loading: Loading,
});

const Paginations = Loadable({
  loader: () => import('./views/Base/Paginations'),
  loading: Loading,
});

const Popovers = Loadable({
  loader: () => import('./views/Base/Popovers'),
  loading: Loading,
});

const ProgressBar = Loadable({
  loader: () => import('./views/Base/ProgressBar'),
  loading: Loading,
});

const Switches = Loadable({
  loader: () => import('./views/Base/Switches'),
  loading: Loading,
});

const Tables = Loadable({
  loader: () => import('./views/Base/Tables'),
  loading: Loading,
});

const Tabs = Loadable({
  loader: () => import('./views/Base/Tabs'),
  loading: Loading,
});

const Tooltips = Loadable({
  loader: () => import('./views/Base/Tooltips'),
  loading: Loading,
});

const BrandButtons = Loadable({
  loader: () => import('./views/Buttons/BrandButtons'),
  loading: Loading,
});

const ButtonDropdowns = Loadable({
  loader: () => import('./views/Buttons/ButtonDropdowns'),
  loading: Loading,
});

const ButtonGroups = Loadable({
  loader: () => import('./views/Buttons/ButtonGroups'),
  loading: Loading,
});

const Buttons = Loadable({
  loader: () => import('./views/Buttons/Buttons'),
  loading: Loading,
});

const Charts = Loadable({
  loader: () => import('./views/Charts'),
  loading: Loading,
});

const Dashboard = Loadable({
  loader: () => import('./views/Dashboard'),
  loading: Loading,
});

const DaDashboard = Loadable({
  loader: () => import('./views/DaDashboard/DaDashboard'),
  loading: Loading,
});

const CoreUIIcons = Loadable({
  loader: () => import('./views/Icons/CoreUIIcons'),
  loading: Loading,
});

const Flags = Loadable({
  loader: () => import('./views/Icons/Flags'),
  loading: Loading,
});

const FontAwesome = Loadable({
  loader: () => import('./views/Icons/FontAwesome'),
  loading: Loading,
});

const SimpleLineIcons = Loadable({
  loader: () => import('./views/Icons/SimpleLineIcons'),
  loading: Loading,
});

const Alerts = Loadable({
  loader: () => import('./views/Notifications/Alerts'),
  loading: Loading,
});

const Badges = Loadable({
  loader: () => import('./views/Notifications/Badges'),
  loading: Loading,
});

const Modals = Loadable({
  loader: () => import('./views/Notifications/Modals'),
  loading: Loading,
});

const Colors = Loadable({
  loader: () => import('./views/Theme/Colors'),
  loading: Loading,
});

const Typography = Loadable({
  loader: () => import('./views/Theme/Typography'),
  loading: Loading,
});

const Widgets = Loadable({ 
  loader: () => import('./views/Widgets/Widgets'),
  loading: Loading,
});

const Users = Loadable({
  loader: () => import('./views/Users/Users'),
  loading: Loading,
});

const UnverifiedUsers = Loadable({
  loader: () => import('./views/Users/UnverifiedUsers'),
  loading: Loading,
});

const Youtubers = Loadable({
  loader: () => import('./views/Youtubers/Youtubers'),
  loading: Loading,
});

const YoutubersCommision = Loadable({
  loader: () => import('./views/Youtubers/CommTable'),
  loading: Loading,
});

const RevenueList = Loadable({
  loader: () => import('./views/Youtubers/RevenueList'),
  loading: Loading,
});

const Revenue = Loadable({
  loader: () => import('./views/Youtubers/Revenue'),
  loading: Loading,
});

const RevenueCommision = Loadable({
  loader: () => import('./views/Youtubers/RevenueComm'),
  loading: Loading,
});

const PredictionRevenueList = Loadable({
  loader: () => import('./views/Youtubers/PredictionRevenueList'),
  loading: Loading,
});

const PredictionRevenue = Loadable({
  loader: () => import('./views/Youtubers/PredictionRevenue'),
  loading: Loading,
});

const PredictionRevenueCommision = Loadable({
  loader: () => import('./views/Youtubers/PredictionRevenueComm'),
  loading: Loading,
});

const TradeRevenueList = Loadable({
  loader: () => import('./views/Youtubers/TradeRevenueList'),
  loading: Loading,
});

const TradeRevenue = Loadable({
  loader: () => import('./views/Youtubers/TradeRevenue'),
  loading: Loading,
});

const TradeRevenueCommision = Loadable({
  loader: () => import('./views/Youtubers/TradeRevenueComm'),
  loading: Loading,
});

const UserData = Loadable({
  loader: () => import('./views/Users/UserData'),
  loading: Loading,
});

const UserAdd = Loadable({
  loader: () => import('./views/Users/UserAdd'),
  loading: Loading,
});

const Contests = Loadable({
  loader: () => import('./views/Contests/Contests'),
  loading: Loading,
});

const OtherGamesContests = Loadable({
  loader: () => import('./views/OtherGamesContest/Contests'),
  loading: Loading,
});



const PendingOtherGamesContests = Loadable({
  loader: () => import('./views/OtherGamesContest/PendingOtherGameContest.js'),
  loading: Loading,
});

const ContestSchedule = Loadable({
  loader: () => import('./views/Contests/ContestSchedule'),
  loading: Loading,
});

const FootballContestSchedule = Loadable({
  loader: () => import('./views/Contests/FootballContestSchedule'),
  loading: Loading,
});

const KabaddiContestSchedule = Loadable({
  loader: () => import('./views/Contests/KabaddiContestSchedule'),
  loading: Loading,
});
const BasketballContestSchedule = Loadable({
  loader: () => import('./views/Contests/BasketballContestSchedule.js'),
  loading: Loading,
});

const LiveFantasyContestSchedule = Loadable({
  loader: () => import('./views/Contests/LiveFantasyContestSchedule'),
  loading: Loading,
});

const ContestData = Loadable({
  loader: () => import('./views/Contests/ContestData'),
  loading: Loading,
});

const OtherGamesContestData = Loadable({
  loader: () => import('./views/OtherGamesContest/ContestData'),
  loading: Loading,
});



const ContestScheduleData = Loadable({
  loader: () => import('./views/Contests/ContestScheduleData'),
  loading: Loading,
});

const ContestBreakup = Loadable({
  loader: () => import('./views/Contests/ContestBreakup'),
  loading: Loading,
});

const OtherGamesContestBreakup = Loadable({
  loader: () => import('./views/OtherGamesContest/ContestBreakup'),
  loading: Loading,
});

const ContestDetails = Loadable({
  loader: () => import('./views/Contests/ContestUserDetails'),
  loading: Loading,
});
const OtherGameContestDetails = Loadable({
  loader: () => import('./views/OtherGamesContest/ContestUserDetails'),
  loading: Loading,
});
const OtherGameContestRooms = Loadable({
  loader: () => import('./views/OtherGamesContest/ContestRooms'),
  loading: Loading,
});

// const OtherGameContestRooms = Loadable({
//   loader: () => import('./views/OtherGamesContest/ContestRooms'),
//   loading: Loading,
// });

const OtherGameContestRoomDetails = Loadable({
  loader: () => import('./views/OtherGamesContest/ContestRoomDetail'),
  loading: Loading,
});
const ContestScheduleDetails = Loadable({
  loader: () => import('./views/Contests/ContestScheduleDetails'),
  loading: Loading,
});

const ContestAutoCreateView = Loadable({
  loader: () => import('./views/Contests/autoCreate/ScheduleList'),
  loading: Loading,
});

const ContestSchedulePointsView = Loadable({
  loader: () => import('./views/Contests/ContestSchedulePointsView'),
  loading: Loading,
});

const ContestSchedulePointsEdit = Loadable({
  loader: () => import('./views/Contests/ContestSchedulePointsEdit'),
  loading: Loading,
});

const SwapPlayerID = Loadable({
  loader: () => import('./views/Contests/SwapPlayerID'),
  loading: Loading,
});

const ContestScheduleNotificationEdit = Loadable({
  loader: () => import('./views/Contests/NotificationAdd'),
  loading: Loading,
});

const ScheduleList = Loadable({
  loader: () => import('./views/Contests/ScheduleList'),
  loading: Loading,
});

const UpdateMegaContestBreakup = Loadable({
  loader: () => import('./views/Contests/UpdateMegaContestBreakup'),
  loading: Loading,
});

const ScheduleAdd = Loadable({
  loader: () => import('./views/Contests/ScheduleAdd'),
  loading: Loading,
});

const UpdateGadgetPrice = Loadable({
  loader: () => import('./views/Contests/customBreakup/updateGadgetPrice'),
  loading: Loading,
});

const updateContestBreakup = Loadable({
  loader: () => import('./views/Contests/customBreakup/updateContestBreakup'),
  loading: Loading,
});

const WinningBreakup = Loadable({
  loader: () => import('./views/otherGameTournament/winning-breakup.js'),
  loading: Loading,
});
const ChangeContestImage = Loadable({
  loader: () => import('./views/otherGameTournament/ChnageTournamentChange.js'),
  loading: Loading,
});

const TournamentList = Loadable({
  loader: () => import('./views/otherGameTournament/other-games-tournament-list.js'),
  loading: Loading,
});
const TournamentPrivateList = Loadable({
  loader: () => import('./views/otherGameTournament/privateTournamentList.js'),
  loading: Loading,
});

const PrivateContestImage = Loadable({
  loader: () => import('./views/otherGameTournament/privateContestImage.js'),
  loading: Loading,
});

const TournamentView = Loadable({
  loader: () => import('./views/otherGameTournament/view-other-games-tournament.js'),
  loading: Loading,
});

const PlayerDetails = Loadable({
  loader: () => import('./views/otherGameTournament/playersDetails.js'),
  loading: Loading,
});
const TournamentPage = Loadable({
  loader: () => import('./views/otherGameTournament/TournamentPage.js'),
  loading: Loading,
});
const TournamentBanner = Loadable({
  loader: () => import('./views/otherGameTournament/tournamentBanner.js'),
  loading: Loading,
});

const UpdateWinningBreakup = Loadable({
  loader: () => import('./views/otherGameTournament/update-winning-breakup.js'),
  loading: Loading,
});

const AdminProfile = Loadable({
  loader: () => import('./views/Admin/Profile'),
  loading: Loading,
});

const AdminEdit = Loadable({
  loader: () => import('./views/Admin/ProfileEdit'),
  loading: Loading,
});

const ForgotPassword = Loadable({
  loader: () => import('./views/Pages/Login/ForgotPassword'),
  loading: Loading,
});

const ResetPassword = Loadable({
  loader: () => import('./views/Pages/Login/ResetPassword'),
  loading: Loading,
});


const Points = Loadable({
  loader: () => import('./views/Points/Points'),
  loading: Loading,
});

const Admins = Loadable({
  loader: () => import('./views/Admins/Admins'),
  loading: Loading,
});

const AdminData = Loadable({
  loader: () => import('./views/Admins/AdminData'),
  loading: Loading,
});

const AdminAdd = Loadable({
  loader: () => import('./views/Admins/AdminAdd'),
  loading: Loading,
});



const ContestCategory = Loadable({
  loader: () => import('./views/Contests/ContestCategory/ContestCategory'),
  loading: Loading,
});

const ContestCategoryAdd = Loadable({
  loader: () => import('./views/Contests/ContestCategory/ContestCategoryAdd'),
  loading: Loading,
});

const ContestCategoryData = Loadable({
  loader: () => import('./views/Contests/ContestCategory/ContestCategoryData'),
  loading: Loading,
});

const UserWithdraw = Loadable({
  loader: () => import('./views/UserWithdraw/UserWithdraw'),
  loading: Loading,
});

const WithdrawRejected = Loadable({
  loader: () => import('./views/UserWithdraw/WithdrawRejected'),
  loading: Loading,
});

const UserWithdrawReport = Loadable({
  loader: () => import('./views/UserWithdraw/UserWithdrawReport'),
  loading: Loading,
});

const UserWithdrawData = Loadable({
  loader: () => import('./views/UserWithdraw/UserWithdrawData'),
  loading: Loading,
});

const PlayerManager = Loadable({
  loader: () => import('./views/PlayerManager/PlayerManager'),
  loading: Loading,
});

const NewPlayerManager = Loadable({
  loader: () => import('./views/NewPlayerManager/PlayerManager'),
  loading: Loading,
});

const TeamManager = Loadable({
  loader: () => import('./views/TeamManager/TeamManager'),
  loading: Loading,
});

const AddPlayerManager = Loadable({
  loader: () => import('./views/PlayerManager/AddPlayerManager'),
  loading: Loading,
});
const AddXfactoryPlayerManager = Loadable({
  loader: () => import('./views/PlayerManager/AddXFactors'),
  loading: Loading,
});


const AddPlayerExchange = Loadable({
  loader: () => import('./views/PlayerExchange/AddPlayerManager'),
  loading: Loading,
});

const AddLiveExchange = Loadable({
  loader: () => import('./views/LiveExchange/AddPlayerManager'),
  loading: Loading,
});

const AddStockExchange = Loadable({
  loader: () => import('./views/StockExchange/AddPlayerManager'),
  loading: Loading,
});

const AddPlayerExchangeNew = Loadable({
  loader: () => import('./views/PlayerExchangeNew/AddPlayerManager'),
  loading: Loading,
});

const PlayerExchnageSchedule = Loadable({
  loader: () => import('./views/PlayerExchange/playerExchnageSchedule'),
  loading: Loading,
});

const FootballPlayerExchnageSchedule = Loadable({
  loader: () => import('./views/PlayerExchange/FootballContestSchedule'),
  loading: Loading,
});

const KabaddiPlayerExchnageSchedule = Loadable({
  loader: () => import('./views/PlayerExchange/KabaddiContestSchedule'),
  loading: Loading,
});

const LiveExchnageSchedule = Loadable({
  loader: () => import('./views/LiveExchange/liveExchnageSchedule'),
  loading: Loading,
});

const FootballLiveExchnageSchedule = Loadable({
  loader: () => import('./views/LiveExchange/FootballContestSchedule'),
  loading: Loading,
});

const KabaddiLiveExchnageSchedule = Loadable({
  loader: () => import('./views/LiveExchange/KabaddiContestSchedule'),
  loading: Loading,
});

const StockExchnageSchedule = Loadable({
  loader: () => import('./views/StockExchange/stockExchnageSchedule'),
  loading: Loading,
});

const FootballStockExchnageSchedule = Loadable({
  loader: () => import('./views/StockExchange/FootballContestSchedule'),
  loading: Loading,
});

const KabaddiStockExchnageSchedule = Loadable({
  loader: () => import('./views/StockExchange/KabaddiContestSchedule'),
  loading: Loading,
});


const UpdateMatchLineup = Loadable({
  loader: () => import('./views/PlayerManager/UpdateMatchLineup'),
  loading: Loading,
});

const seriesManager = Loadable({
  loader: () => import('./views/Series/Series'),
  loading: Loading,
});

const LeaderBoardStatus = Loadable({
  loader: () => import('./views/Series/LeaderboardsStatusRedis'),
  loading: Loading,
});

const WeeklyLeaderboardBreakupManager = Loadable({
  loader: () => import('./views/Series/WeeklyLeaderboardBreakup'),
  loading: Loading,
});

const seriesMatchesManager = Loadable({
  loader: () => import('./views/SeriesMatches/SeriesMatches'),
  loading: Loading,
});

const seriesMatchesManagerNew = Loadable({
  loader: () => import('./views/SeriesMatchesNew/SeriesMatches'),
  loading: Loading,
});

const UpdateSeries = Loadable({
  loader: () => import('./views/Series/UpdateSeries'),
  loading: Loading,
});
const MatchAdd = Loadable({
  loader: () => import('./views/SeriesMatches/UpdateMatch'),
  loading: Loading,
});

const MatchAddNew = Loadable({
  loader: () => import('./views/SeriesMatchesNew/UpdateMatch'),
  loading: Loading,
});

const AddChildMatch = Loadable({
  loader: () => import('./views/SeriesMatches/ChildMatch'),
  loading: Loading,
});

const AddChildMatchNew = Loadable({
  loader: () => import('./views/SeriesMatchesNew/ChildMatch'),
  loading: Loading,
});
const SwapMatchId = Loadable({
  loader: () => import('./views/SeriesMatchesNew/swapMatchId.js'),
  loading: Loading,
});

const AddLiveFantasyMatches = Loadable({
  loader: () => import('./views/SeriesMatches/LiveFantasyMatches'),
  loading: Loading,
});

const AddLiveFantasyMatchesNew = Loadable({
  loader: () => import('./views/SeriesMatchesNew/LiveFantasyMatches'),
  loading: Loading,
});

const LiveFantasyMatchesList = Loadable({
  loader: () => import('./views/SeriesMatches/LiveFantasyMatchList'),
  loading: Loading,
});

const LiveFantasyMatchesListNew = Loadable({
  loader: () => import('./views/SeriesMatchesNew/LiveFantasyMatchList'),
  loading: Loading,
});



const PaymentOptions = Loadable({
  loader: () => import('./views/Settings/PaymentOptions'),
  loading: Loading,
});

const SportOptions = Loadable({
  loader: () => import('./views/Settings/SportOptions'),
  loading: Loading,
});

const Introduction = Loadable({
  loader: () => import('./views/Howtoplay/Introduction'),
  loading: Loading,
});

const CreateTeam = Loadable({
  loader: () => import('./views/Howtoplay/CreateTeam'),
  loading: Loading,
});

const ManageTeam = Loadable({
  loader: () => import('./views/Howtoplay/ManageTeam'),
  loading: Loading,
});

const FAQs = Loadable({
  loader: () => import('./views/Howtoplay/FAQs'),
  loading: Loading,
});

const AboutUs = Loadable({
  loader: () => import('./views/AboutUs/AboutUsView'),
  loading: Loading,
});

const Condition = Loadable({
  loader: () => import('./views/Condition/ConditionView'),
  loading: Loading,
});
const Privacy = Loadable({
  loader: () => import('./views/Privacy/PrivacyView'),
  loading: Loading,
});

const Legality = Loadable({
  loader: () => import('./views/Legality/LegalityView'),
  loading: Loading,
});

const ContactUs = Loadable({
  loader: () => import('./views/ContactUs/ContactUsView'),
  loading: Loading,
});

// const NotificationReceived = Loadable({
//   loader: () => import('./views/NotificationData/NotificationReceived'),
//   loading: Loading,
// });

// const NotificationSend = Loadable({
//   loader: () => import('./views/NotificationData/NotificationSend'),
//   loading: Loading,
// });

// const ReferralBonus = Loadable({
//   loader: () => import('./views/ReferralBonus/ReferralBonus'),
//   loading: Loading,
// });

const Transaction = Loadable({
  loader: () => import('./views/Transaction/Transaction'),
  loading: Loading,
});



// const Gst = Loadable({
//   loader: () => import('./views/Gst/Gst.js'),
//   loading: Loading,
// });

// const LeaderboardGst = Loadable({
  // loader: () => import('./views/Gst/LeaderboardGst'),
//   loading: Loading,
// });

// const Excel = Loadable({
//   loader: () => import('./views/Excel/Excel.js'),
//   loading: Loading,
// });

// const ExcelYouTuber = Loadable({
//   loader: () => import('./views/Excel/YoutuberList.js'),
//   loading: Loading,
// });

const Templates = Loadable({
  loader: () => import('./views/Template/EmailTemplate.js'),
  loading: Loading,
});

const TemplatesView = Loadable({
  loader: () => import('./views/Template/EmailTemplateView.js'),
  loading: Loading,
});

const TemplatesEdit = Loadable({
  loader: () => import('./views/Template/EmailTemplateEdit.js'),
  loading: Loading,
});

// const Contents = Loadable({
//   loader: () => import('./views/Content/Content.js'),
//   loading: Loading,
// });

// const ContentView = Loadable({
//   loader: () => import('./views/Content/ContentView.js'),
//   loading: Loading,
// });

// const ContentEdit = Loadable({
//   loader: () => import('./views/Content/ContentEdit.js'),
//   loading: Loading,
// });

const wallets = Loadable({
  loader: () => import('./views/Wallets/WalletNew.js'),
  loading: Loading,
});
// const wallets = Loadable({
//   loader: () => import('./views/Wallets/Wallets.js'),
//   loading: Loading,
// });

// const pullApiManager = Loadable({
//   loader: () => import('./views/PullApiManager/PullApiManager.js'),
//   loading: Loading,
// });

const csvUploadManager = Loadable({
  loader: () => import('./views/CsvUploadManager/CsvUploadManager.js'),
  loading: Loading,
});

const PurchaseCoupon = Loadable({
  loader: () =>import('./views/PurchaseCoupon/PurchaseCoupon.js'),
  loading: Loading,
});

const CouponAddEdit = Loadable({
  loader: () =>import('./views/PurchaseCoupon/CouponAddEdit.js'),
  loading: Loading
});

const CouponDetails = Loadable({
  loader: () => import('./views/PurchaseCoupon/CouponViewDetails.js'),
  loading: Loading,
});



const Inapp = Loadable({
  loader: () => import('./views/InApp/inapp.js'),
  loading: Loading,
});

const weeklySeriesManager = Loadable({
  loader: () => import('./views/WeeklySeries/WeeklySeries'),
  loading: Loading,
});

const weeklySeriesBreakup = Loadable({
  loader: () => import('./views/WeeklySeries/WeeklySeriesBreakup'),
  loading: Loading,
});

const matchBannerManager = Loadable({
  loader: () => import('./views/MatchBanners/MatchBanners'),
  loading: Loading,
});

const NotificationBanner = Loadable({
  loader: () => import('./views/NotificationBanner/NotificationBanner'),
  loading: Loading,
});

const ReferralUserData = Loadable({
  loader: () => import('./views/YoutubersStats/ReferralUserData'),
  loading: Loading,
});

/** Other Game Section START */
const OtherGamesMatchList = Loadable({
  loader: () => import("./views/OtherGames/Matches/MatchList"),
  loading: Loading,
})

const OtherGamesContestAdd = Loadable({
  loader: () => import("./views/OtherGames/Matches/ContestAdd"),
  loading: Loading,
})

const OtherGameUpdate = Loadable({
  loader: () => import("./views/OtherGames/Matches/GameUpdate"),
  loading: Loading,
})

const OtherGameContestList = Loadable({
  loader: () => import("./views/OtherGames/Matches/ContestList"),
  loading: Loading,
})

const DistributionPandingContest = Loadable({
  loader: () => import("./views/OtherGames/Matches/DistributionPandingContest"),
  loading: Loading,
})

const CommissionContestList = Loadable({
  loader: () => import("./views/OtherGames/Youtubers/CommissionContestList"),
  loading: Loading,
})

const OtherGameContestDetail = Loadable({
  loader: () => import("./views/OtherGames/Matches/ContestDetail"),
  loading: Loading,
})

const OtherGameTransactionList = Loadable({
  loader: () => import("./views/OtherGames/Transaction/Transaction"),
  loading: Loading,
})

const OtherGameRevenueList = Loadable({
  loader: () => import("./views/OtherGames/Youtubers/RevenueList"),
  loading: Loading,
})

const OtherGameMonthRevenueList = Loadable({
  loader: () => import('./views/OtherGames/Youtubers/MonthRevenueList'),
  loading: Loading,
});

const OtherGameRevenue = Loadable({
  loader: () => import('./views/OtherGames/Youtubers/OtherGameRevenue'),
  loading: Loading,
});

const OtherGameRevenueCommision = Loadable({
  loader: () => import('./views/OtherGames/Youtubers/OtherGameRevenueComm'),
  loading: Loading,
});

const GSTList = Loadable({
  loader: () => import('./views/OtherGames/Gst/Gst'),
  loading: Loading,
});

const PrivateContestBreakup = Loadable({
  loader: () => import('./views/OtherGames/PrivateContest/PrivateContestBreakup'),
  loading: Loading,
});
/** Other Game Section END */


/** redis new work START */
// const ContestScheduleRedis = Loadable({
//   loader: () => import('./views/Contests_redis/ContestSchedule'),
//   loading: Loading,
// });
// const FootballContestScheduleRedis = Loadable({
//   loader: () => import('./views/Contests_redis/FootballContestSchedule'),
//   loading: Loading,
// });

// const KabaddiContestScheduleRedis = Loadable({
//   loader: () => import('./views/Contests_redis/KabaddiContestSchedule'),
//   loading: Loading,
// });

// const LiveFantasyContestScheduleRedis = Loadable({
//   loader: () => import('./views/Contests_redis/LiveFantasyContestSchedule'),
//   loading: Loading,
// });
// const ScheduleAddRedis = Loadable({
//   loader: () => import('./views/Contests_redis/ScheduleAdd'),
//   loading: Loading,
// });

const Prediction = Loadable({
  loader: () => import('./views/Contests/Prediction'),
  loading: Loading,
});



// const AddBreakup = Loadable({
//   loader: () => import('./views/OtherGamesLeaderboard/AddBreakup'),
//   loading: Loading,
// });





const PlayerManagerNew = Loadable({
  loader: () => import('./views/NewPlayerManager/PlayerManager'),
  loading: Loading,
});

const AddGateway = Loadable({
  loader: () => import('./views/PaymentGateway/AddGatewayForm'),
  loading: Loading,
});

// AddGatewayForm

// Withdraw

const WithdrawTransaction = Loadable({
  loader: () => import('./views/Withdraw/Withdraw'),
  loading: Loading,
});

// Diposite
const DipositeTransaction = Loadable({
  loader: () => import('./views/Diposite/Diposite'),
  loading: Loading,
});

/** redis new work END */


// https://github.com/ReactTraining/react-router/tree/master/packages/react-router-config
const routes = [
  { path: '/', exact: true, name: 'Home', component: DefaultLayout },
  { path: '/dashboard', name: 'Dashboard', component: Dashboard },
  { path: '/da_dashboard', name: 'DA Dashboard', component: DaDashboard },
  { path: '/theme', exact: true, name: 'Theme', component: Colors },
  { path: '/theme/colors', name: 'Colors', component: Colors },
  { path: '/theme/typography', name: 'Typography', component: Typography },
  { path: '/base', exact: true, name: 'Base', component: Cards },
  { path: '/base/cards', name: 'Cards', component: Cards },
  { path: '/base/forms', name: 'Forms', component: Forms },
  { path: '/base/switches', name: 'Switches', component: Switches },
  { path: '/base/tables', name: 'Tables', component: Tables },
  { path: '/base/tabs', name: 'Tabs', component: Tabs },
  { path: '/base/breadcrumbs', name: 'Breadcrumbs', component: Breadcrumbs },
  { path: '/base/carousels', name: 'Carousel', component: Carousels },
  { path: '/base/collapses', name: 'Collapse', component: Collapses },
  { path: '/base/dropdowns', name: 'Dropdowns', component: Dropdowns },
  { path: '/base/jumbotrons', name: 'Jumbotrons', component: Jumbotrons },
  { path: '/base/list-groups', name: 'List Groups', component: ListGroups },
  { path: '/base/navbars', name: 'Navbars', component: Navbars },
  { path: '/base/navs', name: 'Navs', component: Navs },
  { path: '/base/paginations', name: 'Paginations', component: Paginations },
  { path: '/base/popovers', name: 'Popovers', component: Popovers },
  { path: '/base/progress-bar', name: 'Progress Bar', component: ProgressBar },
  { path: '/base/tooltips', name: 'Tooltips', component: Tooltips },
  { path: '/buttons', exact: true, name: 'Buttons', component: Buttons },
  { path: '/buttons/buttons', name: 'Buttons', component: Buttons },
  { path: '/buttons/button-dropdowns', name: 'Button Dropdowns', component: ButtonDropdowns },
  { path: '/buttons/button-groups', name: 'Button Groups', component: ButtonGroups },
  { path: '/buttons/brand-buttons', name: 'Brand Buttons', component: BrandButtons },
  { path: '/icons', exact: true, name: 'Icons', component: CoreUIIcons },
  { path: '/icons/coreui-icons', name: 'CoreUI Icons', component: CoreUIIcons },
  { path: '/icons/flags', name: 'Flags', component: Flags },
  { path: '/icons/font-awesome', name: 'Font Awesome', component: FontAwesome },
  { path: '/icons/simple-line-icons', name: 'Simple Line Icons', component: SimpleLineIcons },
  { path: '/notifications', exact: true, name: 'Notifications', component: Alerts },
  { path: '/notifications/alerts', name: 'Alerts', component: Alerts },
  { path: '/notifications/badges', name: 'Badges', component: Badges },
  { path: '/notifications/modals', name: 'Modals', component: Modals },
  { path: '/widgets', name: 'Widgets', component: Widgets },
  { path: '/charts', name: 'Charts', component: Charts },
  { path: '/contests', exact: true,  name: 'Contests', component: Contests },
  { path: '/other-games-contests', exact: true,  name: 'Other Games Contests', component: OtherGamesContests },
  { path: '/contests/add', exact: true,  name: 'Add Contest', component: ContestData },
  { path: '/contests/edit', exact: true,  name: 'Edit Contest', component: ContestData },
  { path: '/other-games-contests/add', exact: true,  name: 'Add Other Games Contest', component: OtherGamesContestData },
  { path: '/other-games-contests/edit', exact: true,  name: 'Edit Other Games Contest', component: OtherGamesContestData },
  { path: '/contests/schedule/:id', exact: true,  name: 'Add Contest Schedule', component: ContestScheduleData }, 
  { path: '/contests/get', exact: true,  name: 'Contest Details', component: ContestDetails },
  { path: '/contests/breakup/:id', exact: true,  name: 'Update Contests Breakup', component: ContestBreakup },
  { path: '/other-games-contests/breakup/:id', exact: true,  name: 'Update Other Games Contests Breakup', component: OtherGamesContestBreakup },
  { path: '/pending-other-games-contests', exact: true,  name: 'Pending Other Games Contests', component: PendingOtherGamesContests },

  { path: '/contests/detail/:id', exact: true,  name: 'Contest Details', component: ContestDetails },
  { path: '/other-game-contests/detail/:id', exact: true,  name: 'Other Game Contest Details', component: OtherGameContestDetails },
  { path: '/other-game-contests/rooms/:contest_id/:match_id', exact: true,  name: 'Other Game Contest Details', component: OtherGameContestRooms },
  { path: '/pending-other-game-contests/rooms/:contest_id/:match_id', exact: true,  name: 'Pending Other Game Contest Details', component: PendingOtherGamesContests },
  { path: '/other-game-contests/room-detail/:room_id', exact: true,  name: 'Other Game Contest Details', component: OtherGameContestRoomDetails },
  { path: '/contests_schedule/', exact: true,  name: 'Contests', component: ContestSchedule },
  { path: '/contests_schedule/detail/:sport/:id/:match_id', exact: true,  name: 'Contest Details', component: ContestScheduleDetails },
  { path: '/contests_schedule/view_auto_contest/:sport/:match_id/:id', exact: true,  name: 'Auto Create Contest List', component: ContestAutoCreateView },
  { path: '/contests_schedule/view_points/:sport/:match_id/:series_id', exact: true,  name: 'View Points', component: ContestSchedulePointsView },
  { path: '/contests_schedule/edit_points/:sport/:match_id/:series_id/:player_id', exact: true,  name: 'Edit Points', component: ContestSchedulePointsEdit },
  { path: '/contests_schedule/swap_player_id/:sport/:match_id/:series_id/:player_id', exact: true,  name: 'Edit Points', component: SwapPlayerID },
  { path: '/contests_schedule/noification/:id', exact: true,  name: 'Edit Points', component: ContestScheduleNotificationEdit },

  { path: '/playermanager/add_playerexchange/:sport/:match_id/:local_team/:visitor_team', exact: true, name: 'Add Exchange Players', component: AddPlayerExchange },
  { path: '/playermanager/add_liveExchange/:sport/:match_id/:local_team/:visitor_team', exact: true, name: 'Add Exchange Players', component: AddLiveExchange },
  { path: '/playermanager/add_playerexchange_new/:sport/:match_id/:local_team/:visitor_team', exact: true, name: 'Add Exchange Players', component: AddPlayerExchangeNew },

  { path: '/playermanager/add_stockExchange/:sport/:match_id/:local_team/:visitor_team', exact: true, name: 'Add Exchange Players', component: AddStockExchange },

  { path: '/live-exchange', exact: true, name: ' Exchange Players', component: LiveExchnageSchedule },
  { path: '/football-live-exchange', exact: true, name: ' Exchange Football Players', component: FootballLiveExchnageSchedule },
  { path: '/kabaddi-live-exchange', exact: true, name: ' Exchange Kabaddi Players', component: KabaddiLiveExchnageSchedule },

  { path: '/stock-exchange', exact: true, name: ' Exchange Players', component: StockExchnageSchedule },
  { path: '/football-stock-exchange', exact: true, name: ' Exchange Football Players', component: FootballStockExchnageSchedule },
  { path: '/kabaddi-stock-exchange', exact: true, name: ' Exchange Kabaddi Players', component: KabaddiStockExchnageSchedule },


  { path: '/player-exchnage', exact: true, name: ' Exchange Players', component: PlayerExchnageSchedule },
  { path: '/football-player-exchnage', exact: true, name: ' Exchange Football Players', component: FootballPlayerExchnageSchedule },
  { path: '/kabaddi-player-exchnage', exact: true, name: ' Exchange Kabaddi Players', component: KabaddiPlayerExchnageSchedule },

  { path: '/football_contests_schedule', exact: true,  name: 'Match Listing', component: FootballContestSchedule },
  { path: '/kabaddi_contests_schedule', exact: true,  name: 'Match Listing', component: KabaddiContestSchedule },
  {path: '/basketball_contests_schedule', exact: true,  name: 'Match Listing', component: BasketballContestSchedule },
  { path: '/live-fantasy-contests-schedule', exact: true,  name: 'Match Listing', component: LiveFantasyContestSchedule },

  { path: '/schedule/add/:sport/:id', exact: true,  name: 'Add Match Contest', component: ScheduleAdd },
  { path: '/schedule/:sport/:id', exact: true,  name: 'Match Contest Listing', component: ScheduleList },
  { path: '/schedule/update-contest-breakup/:sport/:match_id/:series_id/:contest_id', exact: true,  name: 'Mega Contest Breakup', component: UpdateMegaContestBreakup },
  { path: '/schedule/update-gadget-price/:sport/:match_id/:contest_id', exact: true,  name: 'Update Gadget Price', component: UpdateGadgetPrice },
  { path: '/schedule/update-contest-price/:sport/:match_id/:contest_id', exact: true,  name: 'Update Contest Price', component: updateContestBreakup },
  

  { path: '/contestcategory', exact: true, name: 'Contest Categories', component: ContestCategory },
  { path: '/contestcategory/add', exact: true, name: 'Add Contest Category', component: ContestCategoryAdd },
  { path: '/contestcategory/edit/:id', exact: true, name: 'Edit Contest Category', component: ContestCategoryAdd },
  { path: '/contestcategory/get/:id', exact: true, name: 'Contest Category Details', component: ContestCategoryData },

  { path: '/youtubers', exact: true,  name: 'Youtubers', component: Youtubers },
  { path: '/youtubers/commision/:id', exact: true,  name: 'Youtuber Commision', component: YoutubersCommision },

  { path: '/revenue-list', exact: true,  name: 'Revenue', component: RevenueList },
  { path: '/revenue/:month_year', exact: true,  name: 'Revenue', component: Revenue },
  { path: '/revenue/commision/:id/:month_year', exact: true,  name: 'Revenue Commision', component: RevenueCommision },

  { path: '/revenue-list-prediction', exact: true,  name: 'Prediction Revenue', component: PredictionRevenueList },
  { path: '/revenue-prediction/:month_year', exact: true,  name: 'Prediction Revenue', component: PredictionRevenue },
  { path: '/revenue/commision-prediction/:id/:month_year', exact: true,  name: 'Prediction Revenue Commision', component: PredictionRevenueCommision },
  
  { path: '/revenue-list-trade', exact: true,  name: 'Revenue', component: TradeRevenueList },
  { path: '/revenue-trade/:month_year', exact: true,  name: 'Revenue', component: TradeRevenue },
  { path: '/revenue/commision-trade/:id/:month_year', exact: true,  name: 'Revenue Commision', component: TradeRevenueCommision },

  { path: '/users', exact: true,  name: 'Users', component: Users },
  { path: '/users/unverified-users', exact: true,  name: 'Unverified Users', component: UnverifiedUsers },
  { path: '/users/add', exact: true, name: 'Add User', component: UserAdd },
  { path: '/users/get/:id', exact: true, name: 'Get User Details', component: UserData },
  { path: '/users/edit/:id', exact: true, name: 'Edit User Details', component: UserAdd },
  { path: '/profile', exact: true, name: 'Admin', component: AdminProfile },
  { path: '/profile/edit/:id', exact: true, name: 'Edit Admin Profile', component: AdminEdit },
  { path: '/password/forgot', exact: true, name: 'Enter Email', component: ForgotPassword },
  { path: '/password/reset', exact: true, name: 'Enter Password', component: ResetPassword },
  
  { path: '/points', exact: true, name: 'Points Details', component: Points },
  { path: '/admins', exact: true, name: 'Sub Admin', component: Admins },
  { path: '/admins/add', exact: true, name: 'Add Sub Admin', component: AdminAdd },
  { path: '/admins/get/:id', exact: true, name: 'Sub Admin Details', component: AdminData },
  { path: '/admins/edit/:id', exact: true, name: 'Edit Sub Admin Details', component: AdminAdd },
  
  { path: '/userwithdrawByPaytm/:type', exact: true, name: 'User Withdraw Request', component: UserWithdraw },
  { path: '/userwithdrawByBank/:type', exact: true, name: 'User Withdraw Request', component: UserWithdraw },
  { path: '/userwithdrawByInstant/:type', exact: true, name: 'User Withdraw Request', component: UserWithdraw },
  // { path: '/instantWithdraw/:type', exact: true, name: 'User Withdraw Request', component: UserWithdraw },
  { path: '/userwithdrawByAboveTen/:type', exact: true, name: 'User Withdraw Request', component: UserWithdraw },
  { path: '/userwithdrawFiveToTen/:type', exact: true, name: 'User Withdraw Request', component: UserWithdraw },
  { path: '/userwithdrawYoutuber/:userType', exact: true, name: 'Youtuber Withdraw Request', component: UserWithdraw },
  { path: '/userwithdrawReport/report', exact: true, name: 'User Withdraw Report', component: UserWithdrawReport },
  { path: '/userwithdraw/:type/:id', exact: true, name: 'User Withdraw Request', component: UserWithdrawData },

  { path: '/withdraw-rejected', exact: true, name: 'User Withdraw Rejected', component: WithdrawRejected },
  
  // { path: '/playermanager/:sport_type', exact: true, name: 'Manage Player Credits', component: PlayerManager },
  { path: '/playermanagerCricket/:sport_type', exact: true, name: 'Cricket Manage Player Credits', component: PlayerManager },
  { path: '/newPlayermanagerCricket/:sport_type', exact: true, name: 'Cricket Manage Player Credits', component: NewPlayerManager },
  { path: '/newPlayermanagerCricket/:series_id/:match_id', exact: true, name: 'ss Cricket Manage Player Credits', component: NewPlayerManager },

  { path: '/playermanagerFootball/:sport_type', exact: true, name: 'Football Manage Player Credits', component: PlayerManager },
  { path: '/newPlayermanagerFootball/:series_id/:match_id/:sport_type', exact: true, name: 'Football Manage Player Credits', component: NewPlayerManager },
  { path: '/newPlayermanagerFootball/:sport_type', exact: true, name: 'Football Manage Player Credits', component: NewPlayerManager },

  { path: '/playermanagerKabaddi/:sport_type', exact: true, name: 'Kabaddi Manage Player Credits', component: PlayerManager },
  { path: '/newPlayermanagerKabaddi/:series_id/:match_id/:sport_type', exact: true, name: 'Football Manage Player Credits', component: NewPlayerManager },
  { path: '/newPlayermanagerKabaddi/:sport_type', exact: true, name: 'Football Manage Player Credits', component: NewPlayerManager },
  { path: '/playermanager/:sport_type/:match_id', exact: true, name: 'Manage Player Credits', component: PlayerManager },

  { path: '/playermanager/add/:sport/:match_id/:local_team/:visitor_team', exact: true, name: 'Add Playing Eleven Players', component: AddPlayerManager },
  { path: '/playermanager/add_xfactor/:sport/:match_id/:local_team/:visitor_team', exact: true, name: 'Add Xfactors Eleven Players', component: AddXfactoryPlayerManager },

  { path: '/playermanager/update-match-lineup/:sport/:series_id/:match_id/:local_team/:visitor_team', exact: true, name: 'Replace Players', component: UpdateMatchLineup },
  { path: '/teammanagerCricket/:sport_type', exact: true, name: 'Manage Cricket Team', component: TeamManager },
  { path: '/teammanagerFootball/:sport_type', exact: true, name: 'Manage Football Team', component: TeamManager },
  { path: '/teammanagerKabaddi/:sport_type', exact: true, name: 'Manage Kabaddi Team', component: TeamManager },

  { path: '/seriesCricket/:sport_type', exact: true, name: 'Cricket Manage Series', component: seriesManager },
  { path: '/leaderBoardStatus/:sport_type', exact: true, name: 'Leaderboard Status', component: LeaderBoardStatus },
  { path: '/seriesFootball/:sport_type', exact: true, name: 'Football Manage Series', component: seriesManager },
  { path: '/seriesKabaddi/:sport_type', exact: true, name: 'Kabaddi Manage Series', component: seriesManager },
  { path: '/seriesBasketball/:sport_type', exact: true, name: 'Basketball Manage Series', component: seriesManager },
  { path: '/series/update-weekly-leaderboard-breakup/:sport_type/:series_id', exact: true, name: 'Weekly Leaderboard Breakup', component: WeeklyLeaderboardBreakupManager },

  { path: '/series-matches-cricket/:sport_type', exact: true, name: 'Manage Cricket Series Matches', component: seriesMatchesManager },
  { path: '/series-matches-football/:sport_type', exact: true, name: 'Manage Football Series Matches', component: seriesMatchesManager },
  { path: '/series-matches-kabaddi/:sport_type', exact: true, name: 'Manage Kabaddi Series Matches', component: seriesMatchesManager },
  { path: '/series-matches-basketball/:sport_type', exact: true, name: 'Manage Basketball Series Matches', component: seriesMatchesManager },
  { path: '/series-matches-cricket-new/:sport_type', exact: true, name: 'Manage Cricket Series Matches', component: seriesMatchesManagerNew },
  { path: '/series-matches-football-new/:sport_type', exact: true, name: 'Manage Football Series Matches', component: seriesMatchesManagerNew },
  { path: '/series-matches-kabaddi-new/:sport_type', exact: true, name: 'Manage Kabaddi Series Matches', component: seriesMatchesManagerNew },
  { path: '/series-matches/:sport_type/:id', exact: true, name: 'Manage Series Matches', component: seriesMatchesManager },
  { path: '/series/update/:sport_type/:id', exact: true, name: 'Update Series', component: UpdateSeries },
  
  { path: '/match-banners-cricket/:sport_type', exact: true, name: 'Manage Cricket Match Banner', component: matchBannerManager },
  { path: '/match-banners-football/:sport_type', exact: true, name: 'Manage Football Match Banner', component: matchBannerManager },
  { path: '/match-banners-kabaddi/:sport_type', exact: true, name: 'Manage Kabaddi Match Banner', component: matchBannerManager },
  { path: '/notification-banner', exact: true, name: 'Notification Banner', component: NotificationBanner },

  
  { path: '/payment-options', exact: true, name: 'Manage Payment Options', component: PaymentOptions },
  { path: '/sport-options', exact: true, name: 'Manage Sport Options', component: SportOptions },
  { path: '/howtoplay/introduction', exact: true, name: 'Manage Introduction', component: Introduction },
  { path: '/howtoplay/createteam', exact: true, name: 'Create Team', component: CreateTeam },
  { path: '/howtoplay/manageteam', exact: true, name: 'Manage Team', component: ManageTeam },
  { path: '/howtoplay/faqs', exact: true, name: 'FAQs', component: FAQs },
  { path: '/aboutus', exact: true, name: 'About Us', component: AboutUs },
  { path: '/condition', exact: true, name: 'Terms', component: Condition },
  { path: '/privacy', exact: true, name: 'Privacy', component: Privacy },
  { path: '/legality', exact: true, name: 'Legality ', component: Legality },
  { path: '/contactus', exact: true, name: 'Contact Us', component: ContactUs },
  // { path: '/usernotifications/receive', exact: true, name: 'Notification', component: NotificationReceived },
  // { path: '/usernotifications/send', exact: true, name: 'Notification', component: NotificationSend },
  
  // { path: '/referralbonus', exact: true, name: 'Referral Bonus', component: ReferralBonus },
  { path: '/transaction', exact: true, name: 'Transactions', component: Transaction },
  { path: '/transaction/:id', exact: true, name: 'User Transactions', component: Transaction },
  { path: '/templates', exact: true, name: 'Email Templates', component: Templates },
  { path: '/templates/get/:id', exact: true, name: 'Email Template Details', component: TemplatesView },
  { path: '/templates/edit/:id', exact: true, name: 'Edit Email Template', component: TemplatesEdit },
  
  // { path: '/contents', exact: true, name: 'Page Manager', component: Contents },
  // { path: '/contents/get/:id', exact: true, name: 'Page Manager Details', component: ContentView },
  // { path: '/contents/edit/:id', exact: true, name: 'Edit Page', component: ContentEdit },
  // { path: '/contents/add', exact: true, name: 'Add Page', component: ContentEdit },
  
  { path: '/wallet/list', exact: true, name: 'User Wallets', component: wallets },
  
  // { path: '/gst', exact: true, name: 'Gst Match List', component: Gst },
  // { path: '/leaderboard-gst', exact: true, name: 'Gst Match List', component: LeaderboardGst },
  // { path: '/excel', exact: true, name: 'Excel File', component: Excel },
  // { path: '/excel/youtuber/list/:date', exact: true, name: 'Excel File', component: ExcelYouTuber },
 
  // { path: '/deposit-withdraw', exact: true, name: 'TDS Listing', component: DepositWithdraw },
  { path: '/match/edit/:sport_type/:id', exact: true, name: 'Edit Match Details', component: MatchAdd },
  { path: '/match/edit-new/:sport_type/:id', exact: true, name: 'Edit Match Details', component: MatchAddNew },

  { path: '/match/live-fantasy-edit-new/:sport_type/:id/:parent_id', exact: true, name: 'Edit Match Details', component: MatchAddNew },
  { path: '/match/live-fantasy-edit/:sport_type/:id/:parent_id', exact: true, name: 'Edit Match Details', component: MatchAdd },
  { path: '/match/create-child-match/:sport_type/:id', exact: true, name: 'Create Chlid Match', component: AddChildMatch },
  { path: '/match/create-child-match-new/:sport_type/:id', exact: true, name: 'Create Chlid Match', component: AddChildMatchNew },
  { path: '/match/swap-match_id/:sport_type/:id/:entity_match_id', exact: true, name: 'Swap Match Id', component: SwapMatchId },
  
  { path: '/match/create-live-fantasy-matches/:sport_type/:id', exact: true, name: 'Create Chlid Match', component: AddLiveFantasyMatches },
  { path: '/match/create-live-fantasy-matches-new/:sport_type/:id', exact: true, name: 'Create Chlid Match', component: AddLiveFantasyMatchesNew },


  { path: '/match/live-fantasy-matches-list/:sport_type/:match_id', exact: true, name: 'Chlid Match List', component: LiveFantasyMatchesList },
  { path: '/match/live-fantasy-matches-list-new/:sport_type/:match_id', exact: true, name: 'Chlid Match List', component: LiveFantasyMatchesListNew },
 
  // { path: '/pull-api-manager', exact: true, name: 'Pull Api Manager', component: pullApiManager },
  { path: '/csv-upload-manager', exact: true, name: 'Csv Upload Manager', component: csvUploadManager },
  { path: '/purchase-coupon', exact: true, name: 'Purchase Coupon Manager', component: PurchaseCoupon},
  { path: '/purchase-coupon/add', exact: true,  name: 'Add Purchase Coupon', component: CouponAddEdit },
  { path: '/purchase-coupon/edit/:id', exact: true,  name: 'Edit Purchase Coupon', component: CouponAddEdit },
  { path: '/purchase-coupon/detail/:id', exact: true,  name: 'Purchase Coupon Details', component: CouponDetails }, 
  

  { path: '/weeklyLeaderboard', exact: true, name: 'Weekly Leaderbaord', component: weeklySeriesManager },
  { path: '/series-price-breakup/:sport_type/:series_id', exact: true, name: 'Weekly Leaderbaord Breakup', component: weeklySeriesBreakup },
  { path: '/referral/users/get/:id', exact: true, name: 'Partner Referral', component: ReferralUserData },
  
  
  { path: '/other-games', exact: true, name: 'Other Games', component: OtherGamesMatchList },
  // { path: '/other-games/schedule-contest-add/:sport/:match_id', exact: true, name: 'Other Games Contest Add', component: OtherGamesContestAdd },
  { path: '/other-games/other-game-update/:sport/:match_id', exact: true, name: 'Other Games Update', component: OtherGameUpdate },
  { path: '/other-games/schedule-contest-list/:sport/:match_id', exact: true, name: 'Other Games Contest List', component: OtherGameContestList },
  { path: '/other-games/distribution-panding-contest/:sport/:match_id', exact: true, name: 'Other Games Contest List', component: DistributionPandingContest },
  { path: '/other-games/youtubers-commission/:sport/:match_id', exact: true, name: 'Youtubers Contest List', component: CommissionContestList },
  { path: '/other-games/contests_schedule/detail/:sport/:contest_id/:match_id', exact: true, name: 'Other Games Contest detail', component: OtherGameContestDetail },
  { path: '/other-games/transaction-list', exact: true, name: 'Other Games Transaction List', component: OtherGameTransactionList },
  { path: '/other-games/revenue-list', exact: true, name: 'Other Games Revenue List', component: OtherGameRevenueList },
  { path: '/other-games/month-revenue-list/:month_year', exact: true, name: 'Other Games Revenue List', component: OtherGameMonthRevenueList },
  { path: '/other-games/revenue/:date', exact: true,  name: 'Other Games Revenue', component: OtherGameRevenue },
  { path: '/other-games/revenue/commision/:id/:date', exact: true,  name: 'Other Games Revenue Commision', component: OtherGameRevenueCommision },
  { path: '/other-games/gst-list', exact: true,  name: 'Other Games GST List', component: GSTList },

  { path: '/other-games/private-contest-breakup', exact: true,  name: 'Other Games Private Contest Breakup List', component: PrivateContestBreakup },
  { path: '/other-games/winning-breakup/:sport/:match_id', exact: true,  name: 'Update Winning Breakup', component: WinningBreakup },
  { path: '/other-games/tournament-list/:match_id', exact: true,  name: 'Tournament List', component: TournamentList },
  { path: '/other-games/private/tournament-list/:match_id', exact: true,  name: 'Private Tournament List', component: TournamentPrivateList },
  { path: '/other-games/private/contest/image/:match_id', exact: true,  name: 'Private Tournament List', component: PrivateContestImage },
  { path: '/other-games/tournament/:sport/:match_id', exact: true,  name: ' Tournament ', component: TournamentPage },
  { path: '/other-games/tournament-banner/:sport/:match_id', exact: true,  name: ' Tournament Banner', component: TournamentBanner },
  { path: '/other-games/tournament-view/:_id', exact: true,  name: 'Tournament View', component: TournamentView },
  { path: '/other-games/tournament-update/:_id', exact: true,  name: 'Tournament Update', component: UpdateWinningBreakup },
  { path: '/other-games/player-details/:_id/:round', exact: true,  name: 'Players Round Wise', component: PlayerDetails },
  { path: '/other-games/tournament_image/:_id/:match_id', exact: true,  name: 'change Tournemnt Image', component: ChangeContestImage },
  

  // redis Work URLs
  // { path: '/contests_schedule_redis/', exact: true,  name: 'Contests', component: ContestScheduleRedis },
  // { path: '/football_contests_schedule_redis', exact: true,  name: 'Match Listing', component: FootballContestScheduleRedis },
  // { path: '/kabaddi_contests_schedule_redis', exact: true,  name: 'Match Listing', component: KabaddiContestScheduleRedis },
  // { path: '/live-fantasy-contests-schedule-redis', exact: true,  name: 'Match Listing', component: LiveFantasyContestScheduleRedis },
  // { path: '/schedule/add-redis/:sport/:id', exact: true,  name: 'Add Match Contest', component: ScheduleAddRedis },

  // Match prediction Section START
  { path: '/contests_schedule/prediction/:match_id/:series_id', exact: true, name: 'Prediction', component: Prediction },
  { path: '/contests_schedule/prediction_child/:match_id/:series_id/:prediction_id', exact: true, name: 'Prediction Child', component: PredictionChildView },
  { path: '/add_breakup/prediction/:match_id/:series_id/:_id', exact: true, name: 'Add Prediction Breakup', component: PredictionPriceBreakup },
  { path: '/prediction_transaction', exact: true, name: 'View Prediction Transaction', component: PredictionTrasactionTable },
  // { path: '/contests_schedule/set-price-breakup', exact: true,  name: 'Edit Contest', component: ContestPriceBreakup },
  { path: '/contests/prediction/breakup', exact: true,  name: 'Update Contests Breakup', component: PredictionBreakup },
  { path: '/user_winning/:prediction_id', exact: true, name: 'View Prediction Transaction', component: UserWinning },
  { path: '/opinion_trading/:match_id/:series_id', exact: true, name: 'Opinion Trading', component: OpinionTrading },
  { path: '/opinion-trading-details/:trade_id', exact: true, name: 'Opinion Trading', component: OpinionTradingDetails },
  { path: '/in_play/:match_id/:series_id', exact: true, name: 'In Play Prediction', component: InPlayPrediction },
  // Match prediction Section END

  { path: '/playermanagerCricketNew/:series_id/:match_id', exact: true, name: 'New Cricket Manage Player Credits', component: PlayerManagerNew },
    // AddGateway
  { path: '/payment-gateway', exact: true, name: 'Payment Gateway', component: AddGateway },

  { path: '/withdraw', exact: true, name: 'Withdraw', component: WithdrawTransaction },
  { path: '/diposite', exact: true, name: 'Diposite', component: DipositeTransaction },
  {path: "/inapp", exact: true, name: "InApp", component: Inapp}


// DipositeTransaction
];

export default routes;
